var swiperRecursosGratuitosTabsBlogPosts1 = new Swiper("#swiperRecursosGratuitosTabsBlogPosts1", {
	spaceBetween: 10,
	slidesPerView: 2.5,
	freeMode: true,
	watchSlidesProgress: true,
    breakpoints: {
        768: {
            slidesPerView: 3,
			allowTouchMove	: false,
		},
    }    	
});

var swiperRecursosGratuitosTabsBlogPosts2 = new Swiper("#swiperRecursosGratuitosTabsBlogPosts2", {
	spaceBetween: 10,
	navigation: {
		nextEl: ".recursos-gratuitos-tabs-blog-posts .swiper-button-next",
		prevEl: ".recursos-gratuitos-tabs-blog-posts .swiper-button-prev",
	},
	thumbs: {
		swiper: swiperRecursosGratuitosTabsBlogPosts1,
	},
	
});